import templateUrl from "webforms/validation-summary.htm";

export default () => ({
  scope: {
    errors: "="
  },
  link(scope, element, attr) {
    scope.title =
      attr.validationSummaryTitle || "Please resolve the following errors:";
    scope.hideTitle = !!attr.hideTitle;
    scope.clear = () => (scope.errors = null);
    scope.getErrors = function() {
      const result = [];
      for (const fieldName in scope.errors)
        for (const e of scope.errors[fieldName]) result.push(e.message);
      return result;
    };
  },
  templateUrl
});
